
const BaseUrl = {
    API_URL: 'https://origo-backend-stag.itechnolabs.tech',    
}
export default BaseUrl;